import { buildInterviewFormValues } from 'features/sendouts/common/utils';
import { buildSendoutInterviewPayload as buildInterviewSchedulePayload } from 'features/sendouts/components/drawers/CreateSendoutDrawer/CreateSendoutDrawer.utils';

import { SENDOUT_INTERVIEW_FORM_FIELDS_MAP } from './SendoutInterviewForm.constants';

const buildEmailPickerValues = (emails = []) =>
  emails.map(email => (typeof email === 'string' ? { work_email: email } : email));

export const buildSendoutInterviewPayload = (formData = {}) => ({
  ...buildInterviewSchedulePayload(formData),
  sendEmailToCandidate:
    formData[SENDOUT_INTERVIEW_FORM_FIELDS_MAP.SendEmailToCandidate.key] === true,
  sendEmailToHiringAuthority:
    formData[SENDOUT_INTERVIEW_FORM_FIELDS_MAP.SendEmailToHiringAuthority.key] === true
});

export const buildSendoutInterviewDefaultValues = (interview = {}) => ({
  ...buildInterviewFormValues(interview),
  otherInterviewerFullName: interview.otherInterviewer?.fullName ?? '',
  otherInterviewerEmail: interview.otherInterviewer?.email ?? '',
  otherInterviewerCarbonCopy: buildEmailPickerValues(interview.ccEmails ?? []),
  [SENDOUT_INTERVIEW_FORM_FIELDS_MAP.SendEmailToCandidate.key]:
    interview[SENDOUT_INTERVIEW_FORM_FIELDS_MAP.SendEmailToCandidate.key] === true,
  [SENDOUT_INTERVIEW_FORM_FIELDS_MAP.SendEmailToHiringAuthority.key]:
    interview[SENDOUT_INTERVIEW_FORM_FIELDS_MAP.SendEmailToHiringAuthority.key] === true
});
